import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss';
import '../layout/sass/_responsiveTable.scss';
import api from '../api/api';
import { FilterContext } from '../contexts/FilterContext';
import { AuthContext } from '../contexts/AuthContext';

export const TabelaCotacao = () => {
    const toast = useRef(null);
    const [cotacoes, setCotacoes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null);
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [rows, setRows] = useState(20);
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const { filter, setFilter } = useContext(FilterContext);
    const status = [{
        label: 'Ativo',
        value: true,
    }, {
        label: 'Inativo',
        value: false
    }];
    const [selectedStatus, setSelectedStatus] = useState(null);
    const filterStatus = renderFilterStatus();

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Cotações</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <Button
                        label="Adicionar"
                        className="p-mb-2 p-button-primary"
                        icon="pi pi-plus"
                        iconPos="left"
                        type="button"
                        onClick={() => history.push('/cotacao/create')}
                    />
                </div>
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => handleLimparClick()}
                    />
                </div>
            </div>
        </div>
    );


    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
                'id': { value: null, matchMode: 'equals' },
                'nome': { value: '', matchMode: 'contains' },
                'tipo': { value: '', matchMode: 'contains' },
                'ativo': { value: null, matchMode: 'equals' }
            },
        });
    };

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC');
        } else if (sortable === 'DESC') {
            setSortable('ASC');
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setFilter(event);
    }

    const getCotacoes = useCallback(async (event) => {
        setIsLoading(true);
        setCotacoes([]);

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
            }, 250);
        }

        try {

            if (filter.filters === undefined) {
                if(event === undefined) {
                    const response = await api.get(`cotacao?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(cotacao => {
                        setCotacoes(cotacaoes => [...cotacaoes, cotacao])
                    })
                } else {
                    const response = await api.get(`cotacao?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(cotacao => {
                        setCotacoes(cotacaoes => [...cotacaoes, cotacao])
                    })
                }

                const respElements = await api.get(`cotacao?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                const pesquisa = {
                    "id": filter.filters['id'] !== undefined ? filter.filters['id'].value : null,
                    "nome": filter.filters['nome'] !== undefined ? filter.filters['nome'].value : '',
                    "tipo": filter.filters['tipo'] !== undefined ? filter.filters['tipo'].value : '',
                    "ativo": filter.filters['ativo'] !== undefined ? filter.filters['ativo'].value : null,
                }

                if (event === undefined) {
                    const respElements = await api.post(`cotacao/searchCotacao/${sortable}/${sortableCampo}`, pesquisa);
                    respElements.data.content.forEach(cotacao => {
                        setCotacoes(cotacoes => [...cotacoes, cotacao]);
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`cotacao/searchCotacao/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(cotacao => {
                        setCotacoes(cotacoes => [...cotacoes, cotacao]);
                    })
                    setTotalRecords(respElements.data.totalElements);
                }
            }

        } catch (error) {
            if (filter !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`cotacao?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(cotacao => {
                        setCotacoes(cotacoes => [...cotacoes, cotacao])
                    })
                } else {
                    const response = await api.get(`cotacao?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(cotacao => {
                        setCotacoes(cotacoes => [...cotacoes, cotacao])
                    })

                }

                const respElements = await api.get(`cotacao?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter cotações', detail: error.toString() });
            }
        }

        setIsLoading(false);
    }, [filter, sortable, sortableCampo]);

    useEffect(() => {
        const fetchCotacoes = async () => {
            try {
                await getCotacoes();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() })
            }
        }
        fetchCotacoes();

    }, [getCotacoes])

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />
            </div>
        );
    };

    const idBodyTemplate = (rowData) => {
        return (
            <p style={{ textAlign: 'left' }}>
                <span className="p-column-title">Código</span>
                <span className="table-data">{rowData.id}</span>
            </p>
        );
    };

    const nomeBodyTemplate = (rowData) => {
        return (
            <p style={{ textAlign: 'left' }}>
                <span className="p-column-title">Lojista / Produtor</span>
                <span className="table-data">
                    {rowData?.nome || rowData?.pessoa?.nome}
                </span>
            </p>
        );
    };

    const tipoBodyTemplate = (rowData) => {
        return (
            <p style={{ textAlign: 'left' }}>
                <span className="p-column-title">Tipo</span>
                <span className="table-data">{rowData?.pessoa?.pessoaTipo ? rowData?.pessoa?.pessoaTipo?.descricao : rowData?.tipo}</span>
            </p>
        );
    };

    const ativoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Status</span>
                <Button onClick={() => handleEditAtivo(rowData)} className="p-button-rounded" style={{ color: 'white', backgroundColor: rowData.ativo === true ? '#228B22' : '#FFA500' }} label={rowData.ativo === true ? 'Ativo' : 'Não Ativo '} />
            </React.Fragment>
        );
    }

    const handleEditAtivo = async (data) => {
        try {
            const response = await api.get(`cotacao/${data.id}`);

            const tempData = {
                id: response.data.id,
                pessoaId: response.data.pessoaId,
                ativo: !response.data.ativo,
            };

            await api.put(`cotacao`, tempData);

            setCotacoes((cotacoes) =>
                cotacoes.map((item) =>
                    item.id === data.id ? { ...item, ativo: tempData.ativo } : item
                )
            );

            toast.current.show({
                severity: 'success',
                summary: 'Status Atualizado',
                detail: `A cotação ${data.id} foi marcada como ${tempData.ativo ? 'Ativa' : 'Não Ativa'}`,
                life: 3000,
            });
        } catch (error) {
            console.error("Erro ao atualizar status ativo:", error);

            toast.current.show({
                severity: 'error',
                summary: 'Erro ao Atualizar',
                detail: 'Ocorreu um erro ao atualizar o status da cotação.',
                life: 3000,
            });
        }
    };

    const handleEditClick = (data) => {
        history.push(`/cotacao/edit/${data.id}`);
    };

    const handleDeleteClick = (data) => {
        data['userEmail'] = user.email;

        confirmDialog({
            message: `Você tem certeza que quer remover a cotação ${data.id}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    await api.delete(`cotacao/${data.id}`);

                    setCotacoes((prevCotacoes) => prevCotacoes.filter(item => item.id !== data.id));

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Cotação ${data.id} removida com sucesso` });
                } catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a cotação', detail: error.response ? error.response.data : error.toString() });
                } finally {
                    setIsDeleting(false);
                }
            },
            reject: () => { return; }
        });
    };

    const onStatusCotacaoSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'ativo', 'equals');
            setSelectedStatus(event.value);
        }
        else
            dt.filter(true, 'ativo', 'equals');
    }

    function renderFilterStatus() {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => onStatusCotacaoSearchChange(e)}
                placeholder="Selecione um status"
                className="p-column-filter"
                showClear={true} />
        );
    }

    return (
        <>

            <Toast ref={toast} position="bottom-right" />
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
                <div className="card p-col-12 datatable-responsive-demo">
                    <DataTable
                        totalRecords={totalRecords}
                        lazy
                        first={first}
                        onPage={getCotacoes}
                        ref={(element) => setDt(element)}
                        header={header}
                        value={cotacoes}
                        filterDisplay="row"
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma cotação encontrada"
                        loading={isLoading}
                        dataKey="id"
                        paginator
                        rows={rows}
                        currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} cotações`}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                        onSort={onSort}
                        onFilter={onFilter}
                        filters={filter.filters}
                    >
                        <Column
                            field="id"
                            header="Código"
                            sortable
                            body={idBodyTemplate}
                            filter
                            filterMatchMode='contains'
                            filterPlaceholder={filter.filters != undefined && (filter.filters.id != undefined && filter.filters.id.value != null) ? filter.filters.id.value : "Pesquisar pelo Código"}
                        />
                        <Column
                            field="nome"
                            header="Nome"
                            sortable
                            body={nomeBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder={filter.filters != undefined && (filter.filters.nome != undefined && filter.filters.nome.value != '') ? filter.filters.nome.value : "Pesquisar pelo lojista/produtor"}
                        />
                        <Column
                            field="tipo"
                            header="Tipo"
                            sortable
                            body={tipoBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder={filter.filters != undefined && (filter.filters.tipo != undefined && filter.filters.tipo.value != '') ? filter.filters.tipo.value : "Pesquisar pelo tipo"}
                        />
                        <Column
                            field="ativo"
                            header="Ativo"
                            sortable
                            body={ativoBodyTemplate}
                            filter
                            filterMatchMode='equals'
                            filterElement={filterStatus}
                        />
                        <Column header="Ações" body={actionBodyTemplate} />
                    </DataTable>
                </div>
            </div>
        </>
    );
};
